import {LeftNavigationLazy} from 'app/components/leftNavigation/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineLeftNavigation(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-left-navigation')) {
        return;
    }

    customElements.define(
        'gem-left-navigation',
        class extends WebComponentLoader {
            reactLazyComponent = LeftNavigationLazy;
        },
    );
}
